<template>
  <div class="body">
    <!-- banner -->
    <banner></banner>
    <!-- <div>
      <el-carousel id="el-carousel">
        <el-carousel-item v-for="(item,index) in bannerList" :key="index" style="height:100%">
          <img :title="item.title" :src="$imgRoot+'/'+item.image" width="100%" />
        </el-carousel-item>
      </el-carousel>
    </div> -->
    <br />
    <!-- 全站新闻 -->
    <gloablNews></gloablNews>
    <!-- main -->
    <mainBody></mainBody>
    <br />
  </div>
</template>

<script>
  import gloablNews from './components/globalNews';
  import mainBody from './components/mainBody';
  import banner from './components/banner';
  export default {
    components: {
      gloablNews,
      mainBody,
      banner
    },
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/index/index.vue